import { Badge, Stack } from '@chronosphereio/chrono-ui';
import { memo, useMemo } from 'react';
import { VariableValue } from '@/core';

const SPLIT_PANEL_GROUP_HEADER_BADGE_TEXT =
  'This is a split panel group, changes are propagated from the main instance above.';

interface PanelGroupBadgesProps {
  splitVariableName: string;
  isMainPanelGroup?: boolean;
  splitVariableValue?: VariableValue;
}

export const PanelGroupBadges = memo(function PanelGroupBadges(props: PanelGroupBadgesProps) {
  const { isMainPanelGroup, splitVariableName, splitVariableValue } = props;

  const variableBadgeText = useMemo(() => {
    if (!splitVariableValue) return undefined;
    return `${splitVariableName}=${splitVariableValue}`;
  }, [splitVariableName, splitVariableValue]);

  if (!variableBadgeText) return null;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {isMainPanelGroup && (
        <Badge
          label="Main"
          variant="info"
          size="small"
          TooltipContent={`This is the main instance used to create split panel groups for the $${splitVariableName} variable. To edit the split groups, update this instance.`}
        />
      )}
      {variableBadgeText && (
        <Badge
          label={variableBadgeText}
          size="small"
          TooltipContent={!isMainPanelGroup ? SPLIT_PANEL_GROUP_HEADER_BADGE_TEXT : ''}
        />
      )}
    </Stack>
  );
});
